import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { LitterAddBookmarkMutation, LitterAddBookmarkMutationVariables } from '@gql/graphql';
import { useCallback } from 'react';
import { MT_WISHLIST_GET_BOOKMARKS } from '../../MtWishlistPageController/api/useGetBookmarks';
import { LITTER_GET_BOOKMARK } from './useGetBookmark';

export const LITTER_ADD_BOOKMARK = graphql(`
  mutation LitterAddBookmark($data: AccountUpdateInput!) {
    accountMeUpdate(data: $data) {
      id
      bookmarks {
        id
        litter {
          id
        }
      }
    }
  }
`);

export const useAddBookmark = () => {
  const [add, { data, loading, error }] = useMutation<
    LitterAddBookmarkMutation,
    LitterAddBookmarkMutationVariables
  >(LITTER_ADD_BOOKMARK, {
    awaitRefetchQueries: true,
    refetchQueries: [LITTER_GET_BOOKMARK, MT_WISHLIST_GET_BOOKMARKS],
  });

  const addBookmark = useCallback(
    (litterId: number) => {
      return add({
        variables: {
          data: {
            bookmarks: { create: [{ litter: { connect: { id: litterId } } }] },
          },
        },
      });
    },
    [add],
  );

  return {
    addBookmark,
    addBookmarkLoading: loading,
    addBookmarkError: error,
    addBookmarkData: data,
  };
};
